import React, { useEffect, useState } from "react"
import {
  CAN_REDO_COMMAND,
  CAN_UNDO_COMMAND,
  COMMAND_PRIORITY_CRITICAL,
  REDO_COMMAND,
  UNDO_COMMAND,
} from "lexical"
import { NextIcon, PrevIcon } from "@editor/theme/editorIcons"
import { mergeRegister } from "@lexical/utils"

import { Button, Tooltip } from "@dit/core-frontend"

export const ChangeHistory = ({
  activeEditor,
  editor,
  updateToolbar,
  setIsEditable,
  isEditable,
  buttonProps,
}) => {
  const [canUndo, setCanUndo] = useState(false)
  const [canRedo, setCanRedo] = useState(false)

  useEffect(() => {
    return mergeRegister(
      editor.registerEditableListener((editable) => {
        setIsEditable(editable)
      }),
      activeEditor.registerUpdateListener(({ editorState }) => {
        editorState.read(() => {
          updateToolbar()
        })
      }),
      activeEditor.registerCommand(
        CAN_UNDO_COMMAND,
        (payload) => {
          setCanUndo(payload)
          return false
        },
        COMMAND_PRIORITY_CRITICAL,
      ),
      activeEditor.registerCommand(
        CAN_REDO_COMMAND,
        (payload) => {
          setCanRedo(payload)
          return false
        },
        COMMAND_PRIORITY_CRITICAL,
      ),
    )
  }, [activeEditor, editor, updateToolbar])
  return (
    <>
      <Tooltip content="Отменить ввод">
        <Button
          {...buttonProps}
          kind="borderless"
          vertSize="32"
          disabled={!canUndo || !isEditable}
          onClick={() => {
            activeEditor.dispatchCommand(UNDO_COMMAND, undefined)
          }}
          className=""
        >
          <PrevIcon />
        </Button>
      </Tooltip>

      <Tooltip content="Вернуть ввод">
        <Button
          {...buttonProps}
          kind="borderless"
          vertSize="32"
          disabled={!canRedo || !isEditable}
          onClick={() => {
            activeEditor.dispatchCommand(REDO_COMMAND, undefined)
          }}
          className=""
        >
          <NextIcon />
        </Button>
      </Tooltip>
    </>
  )
}
